// extracted by mini-css-extract-plugin
export var callCard = "_ns-0";
export var callMessageButton = "_ns-1";
export var helpIcon = "_ns-3";
export var helpIconContainer = "_ns-4";
export var verticalDivider = "_ns-2";